import { render, staticRenderFns } from "./ClassCertificates.vue?vue&type=template&id=a84b8026&"
import script from "./ClassCertificates.vue?vue&type=script&lang=js&"
export * from "./ClassCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports